
export const data = [
    {
        title: "Revanue",
        currencySign: "\u20B9",
        moneyRate: "+1.4",
        moneyAmount: 2123,
        arrowType: "down"
    },
    {
        title: "Sales",
        currencySign: "\u20B9",
        moneyRate: "+11.4",
        moneyAmount: 4412,
        arrowType: "up"
    },
    {
        title: "Cost",
        currencySign: "\u20B9",
        moneyRate: "-7.4",
        moneyAmount: 1198,
        arrowType: "down"
    }
]
export const chartData = [
    {
        name: 'Jan',
        "Active User": Math.round(Math.random()*4000+1000),
    },
    {
        name: 'Feb',
        "Active User": Math.round(Math.random()*4000+1000),
    },
    {
        name: 'March',
        "Active User": Math.round(Math.random()*4000+1000),
    },
    {
        name: 'April',
        "Active User": Math.round(Math.random()*4000+1000),
    },
    {
        name: 'May',
        "Active User": Math.round(Math.random()*4000+1000),
    },
    {
        name: 'June',
        "Active User":Math.round(Math.random()*4000+1000),
    },
    {
        name: 'July',
        "Active User": Math.round(Math.random()*4000+1000),
    },
    {
        name: 'Aug',
        "Active User": Math.round(Math.random()*4000+1000),
    },
    {
        name: 'Sept',
        "Active User": Math.round(Math.random()*4000+1000),
    },
    {
        name: 'Oct',
        "Active User": Math.round(Math.random()*4000+1000)
    },
    {
        name: 'Nov',
        "Active User": Math.round(Math.random()*4000+1000),
    },
    {
        name: 'Dec',
        "Active User": Math.round(Math.random()*4000+1000),
    },

]

export const newUserData = [
    {
        name:'Paul Walker',
        avatarImg:"https://hips.hearstapps.com/hmg-prod/images/paul-walker-21044993-1-402.jpg",
        profession:"Racer"
    },
    {
        name:'Vin Diesel',
        avatarImg:"https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/VinDieselMarch09.jpg/220px-VinDieselMarch09.jpg",
        profession:"Mechanic"
    },
    {
        name:'Gerard Butler',
        avatarImg:"https://people.com/thmb/YCmWgttLnpdfjCNLv16iJKFRZJU=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc():focal(734x267:736x269)/Gerard-Butler-cb61ecdb19b0405891b92e5915faf941.jpg",
        profession:"Student"
    },
    {
        name:'Dwayne Johnson',
        avatarImg:"https://flxt.tmsimg.com/assets/235135_v9_bb.jpg",
        profession:"Student"
    },
    {
        name:'Ethan Hunt',
        avatarImg:"https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/299cbff6-dffd-4a38-9820-6ee3fe9509a2/d9amn0q-ca842e4b-56a6-4d87-bb4b-bc94f749fee5.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzI5OWNiZmY2LWRmZmQtNGEzOC05ODIwLTZlZTNmZTk1MDlhMlwvZDlhbW4wcS1jYTg0MmU0Yi01NmE2LTRkODctYmI0Yi1iYzk0Zjc0OWZlZTUuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.kooZ6zpXXVZ6Porq9sd0dEXo1EAsz4dF6GgARAIs6J8",
        profession:"Officer"
    }
]

export const latestTransactions = [
    {
        name:'Paul Walker',
        avatarImg:"https://hips.hearstapps.com/hmg-prod/images/paul-walker-21044993-1-402.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Approved"
    },
    {
        name:'Vin Diesel',
        avatarImg:"https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/VinDieselMarch09.jpg/220px-VinDieselMarch09.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Approved"
    },
    {
        name:'Gerard Butler',
        avatarImg:"https://people.com/thmb/YCmWgttLnpdfjCNLv16iJKFRZJU=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc():focal(734x267:736x269)/Gerard-Butler-cb61ecdb19b0405891b92e5915faf941.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Pending"
    },
    {
        name:'Dwayne Johnson',
        avatarImg:"https://flxt.tmsimg.com/assets/235135_v9_bb.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Declined"
    },
    {
        name:'Ethan Hunt',
        avatarImg:"https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/299cbff6-dffd-4a38-9820-6ee3fe9509a2/d9amn0q-ca842e4b-56a6-4d87-bb4b-bc94f749fee5.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzI5OWNiZmY2LWRmZmQtNGEzOC05ODIwLTZlZTNmZTk1MDlhMlwvZDlhbW4wcS1jYTg0MmU0Yi01NmE2LTRkODctYmI0Yi1iYzk0Zjc0OWZlZTUuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.kooZ6zpXXVZ6Porq9sd0dEXo1EAsz4dF6GgARAIs6J8",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Approved"
    },
    
    {
        name:'Ludacris',
        avatarImg:"https://upload.wikimedia.org/wikipedia/commons/0/0e/Ludacris_2008_%28cropped%29.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Declined"
    },
    {
        name:'Tyrese Gibson',
        avatarImg:"https://upload.wikimedia.org/wikipedia/commons/2/2d/TyreseGibsonDec08.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Approved"
    },
    {
        name:'Tyrese Gibson',
        avatarImg:"https://upload.wikimedia.org/wikipedia/commons/2/2d/TyreseGibsonDec08.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Approved"
    },  {
        name:'Tyrese Gibson',
        avatarImg:"https://upload.wikimedia.org/wikipedia/commons/2/2d/TyreseGibsonDec08.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Approved"
    },  {
        name:'Tyrese Gibson',
        avatarImg:"https://upload.wikimedia.org/wikipedia/commons/2/2d/TyreseGibsonDec08.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Approved"
    },  {
        name:'Tyrese Gibson',
        avatarImg:"https://upload.wikimedia.org/wikipedia/commons/2/2d/TyreseGibsonDec08.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Approved"
    },  {
        name:'Tyrese Gibson',
        avatarImg:"https://upload.wikimedia.org/wikipedia/commons/2/2d/TyreseGibsonDec08.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Approved"
    },
    {
        name:'Tyrese Gibson',
        avatarImg:"https://upload.wikimedia.org/wikipedia/commons/2/2d/TyreseGibsonDec08.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Approved"
    },  {
        name:'Tyrese Gibson',
        avatarImg:"https://upload.wikimedia.org/wikipedia/commons/2/2d/TyreseGibsonDec08.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Approved"
    },  {
        name:'Tyrese Gibson',
        avatarImg:"https://upload.wikimedia.org/wikipedia/commons/2/2d/TyreseGibsonDec08.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Approved"
    },  {
        name:'Tyrese Gibson',
        avatarImg:"https://upload.wikimedia.org/wikipedia/commons/2/2d/TyreseGibsonDec08.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Approved"
    },  {
        name:'Tyrese Gibson',
        avatarImg:"https://upload.wikimedia.org/wikipedia/commons/2/2d/TyreseGibsonDec08.jpg",
        date:"27 April 2022",
        price:Math.round(Math.random()*4000+1000),
        currencySign: '\u20B9',
        status: "Approved"
    },
]



  
export const userListRow = [
    {   id: 1, 
        username: 'paulwalker', 
        avatar:'https://hips.hearstapps.com/hmg-prod/images/paul-walker-21044993-1-402.jpg',
        email:'paulwalker@mail.com',
        status:'active',
        transaction:12332
    },
    {   id: 2, 
        username: 'paulwalker', 
        avatar:'https://hips.hearstapps.com/hmg-prod/images/paul-walker-21044993-1-402.jpg',
        email:'paulwalker@mail.com',
        status:'active',
        transaction:12332
    },
    {   id: 3, 
        username: 'paulwalker', 
        avatar:'https://hips.hearstapps.com/hmg-prod/images/paul-walker-21044993-1-402.jpg',
        email:'paulwalker@mail.com',
        status:'active',
        transaction:12332
    },
    {   id: 4, 
        username: 'paulwalker', 
        avatar:'https://hips.hearstapps.com/hmg-prod/images/paul-walker-21044993-1-402.jpg',
        email:'paulwalker@mail.com',
        status:'active',
        transaction:12332
    },
    {   id: 5, 
        username: 'paulwalker', 
        avatar:'https://hips.hearstapps.com/hmg-prod/images/paul-walker-21044993-1-402.jpg',
        email:'paulwalker@mail.com',
        status:'active',
        transaction:12332
    },
    {   id: 6, 
        username: 'paulwalker', 
        avatar:'https://hips.hearstapps.com/hmg-prod/images/paul-walker-21044993-1-402.jpg',
        email:'paulwalker@mail.com',
        status:'active',
        transaction:12332
    },
    {   id: 7, 
        username: 'paulwalker', 
        avatar:'https://hips.hearstapps.com/hmg-prod/images/paul-walker-21044993-1-402.jpg',
        email:'paulwalker@mail.com',
        status:'active',
        transaction:12332
    },
    {   id: 8, 
        username: 'paulwalker', 
        avatar:'https://hips.hearstapps.com/hmg-prod/images/paul-walker-21044993-1-402.jpg',
        email:'paulwalker@mail.com',
        status:'active',
        transaction:12332
    },
    {   id: 9, 
        username: 'paulwalker', 
        avatar:'https://hips.hearstapps.com/hmg-prod/images/paul-walker-21044993-1-402.jpg',
        email:'paulwalker@mail.com',
        status:'active',
        transaction:12332
    },
    {   id: 10, 
        username: 'paulwalker', 
        avatar:'https://hips.hearstapps.com/hmg-prod/images/paul-walker-21044993-1-402.jpg',
        email:'paulwalker@mail.com',
        status:'active',
        transaction:12332
    },
    {   id: 11, 
        username: 'paulwalker', 
        avatar:'https://hips.hearstapps.com/hmg-prod/images/paul-walker-21044993-1-402.jpg',
        email:'paulwalker@mail.com',
        status:'active',
        transaction:12332
    },
    {   id: 12, 
        username: 'paulwalker', 
        avatar:'https://hips.hearstapps.com/hmg-prod/images/paul-walker-21044993-1-402.jpg',
        email:'paulwalker@mail.com',
        status:'active',
        transaction:12332
    },
    {   id: 13, 
        username: 'paulwalker', 
        avatar:'https://hips.hearstapps.com/hmg-prod/images/paul-walker-21044993-1-402.jpg',
        email:'paulwalker@mail.com',
        status:'active',
        transaction:12332
    }
    
  ];

    
  export const productListRow= [
    {   id: 1, 
        name: 'Acer 24 2K Monitor', 
        image:'https://images.acer.com/is/image/acer/vt0_vt240y_wp_01?$Line-Overview-M1-M2-S$',
        stock:17,
        status:'active',
        price:12332
    },
    {   id: 2, 
        name: 'Acer 24 2K Monitor', 
        image:'https://images.acer.com/is/image/acer/vt0_vt240y_wp_01?$Line-Overview-M1-M2-S$',
        stock:17,
        status:'active',
        price:12332
    },
    {   id: 3, 
        name: 'Acer 24 2K Monitor', 
        image:'https://images.acer.com/is/image/acer/vt0_vt240y_wp_01?$Line-Overview-M1-M2-S$',
        stock:17,
        status:'active',
        price:12332
    },
    {   id: 4, 
        name: 'Acer 24 2K Monitor', 
        image:'https://images.acer.com/is/image/acer/vt0_vt240y_wp_01?$Line-Overview-M1-M2-S$',
        stock:17,
        status:'active',
        price:12332
    },
    {   id: 5, 
        name: 'Acer 24 2K Monitor', 
        image:'https://images.acer.com/is/image/acer/vt0_vt240y_wp_01?$Line-Overview-M1-M2-S$',
        stock:17,
        status:'active',
        price:12332
    },
    {   id: 6, 
        name: 'Acer 24 2K Monitor', 
        image:'https://images.acer.com/is/image/acer/vt0_vt240y_wp_01?$Line-Overview-M1-M2-S$',
        stock:17,
        status:'active',
        price:12332
    },
    {   id: 7, 
        name: 'Acer 24 2K Monitor', 
        image:'https://images.acer.com/is/image/acer/vt0_vt240y_wp_01?$Line-Overview-M1-M2-S$',
        stock:17,
        status:'active',
        price:12332
    },
    {   id: 8, 
        name: 'Acer 24 2K Monitor', 
        image:'https://images.acer.com/is/image/acer/vt0_vt240y_wp_01?$Line-Overview-M1-M2-S$',
        stock:17,
        status:'active',
        price:12332
    },
    {   id: 9, 
        name: 'Acer 24 2K Monitor', 
        image:'https://images.acer.com/is/image/acer/vt0_vt240y_wp_01?$Line-Overview-M1-M2-S$',
        stock:17,
        status:'active',
        price:12332
    },
    {   id: 10, 
        name: 'Acer 24 2K Monitor', 
        image:'https://images.acer.com/is/image/acer/vt0_vt240y_wp_01?$Line-Overview-M1-M2-S$',
        stock:17,
        status:'active',
        price:12332
    },
    {   id: 11, 
        name: 'Acer 24 2K Monitor', 
        image:'https://images.acer.com/is/image/acer/vt0_vt240y_wp_01?$Line-Overview-M1-M2-S$',
        stock:17,
        status:'active',
        price:12332
    },
    {   id: 12, 
        name: 'Acer 24 2K Monitor', 
        image:'https://images.acer.com/is/image/acer/vt0_vt240y_wp_01?$Line-Overview-M1-M2-S$',
        stock:17,
        status:'active',
        price:12332
    },
    {   id: 13, 
        name: 'Acer 24 2K Monitor', 
        image:'https://images.acer.com/is/image/acer/vt0_vt240y_wp_01?$Line-Overview-M1-M2-S$',
        stock:17,
        status:'active',
        price:12332
    },
  ];
  export const productChartData = [
    {
        name: 'Jan',
        "Sales": Math.round(Math.random()*4000+1000),
    },
    {
        name: 'Feb',
        "Sales": Math.round(Math.random()*4000+1000),
    },
    {
        name: 'March',
        "Sales": Math.round(Math.random()*4000+1000),
    }

]